import React from 'react';
import { Route, Routes } from 'react-router-dom';

import AlarmeAdmin from '../../composant/AlarmeAdmin/AlarmeAdmin';
import Tasks from '../../composant/Tasks/Tasks';
import Capteur from '../../composant/Capteur/Capteur';
import ExportImpressionEcran from '../../composant/ExportImpressionEcran/ExportImpressionEcran';
import FiltreParProjet from '../../composant/FiltreParProjet/FiltreParProjet';
import Graphe from '../../composant/Graphe/Graphe';
import InterfaceClient from '../../composant/InterfaceClient/InterfaceClient';
import Maintenance from '../../composant/Maintenance/Maintenance';
import Projet from '../../composant/Projet/Projet';
import Rapport from '../../composant/Rapport/Rapport';
import Utilisateur from '../../composant/Utilisateur/Utilisateur';
import AideAdmin from '../AideAdmin/AideAdmin';
import Formation from '../Formation/Formation';

import { useSelector } from 'react-redux';
import * as url from '../../ressources/glossaires/glossaire_liens_pages';
import * as privilege from '../../ressources/glossaires/glossaire_privileges';

import Vue from '../../composant/Vue/Vue';
import AccesRestreins from '../../hoc/AccesRestreins/AccesRestreins';
import Info from '../EnTete/Info/Info';

import OngletsClient from '../../composant/InterfaceClient/Tabs/OngletsClient';
import Profil from '../../composant/Profil/Profil';
import GestionDonnees from '../../composant/GestionDonnees/GestionDonneesDemo';
import SensorDataTab from '../../composant/GestionDonnees/tabs/SensorDataTab';
import styles from './ConteneurCentral.module.scss';

import PlanningVue from 'composant/Vue/PlanningVue/PlanningVueElectrovanne';
import LabelEventGraphGeoDemo from '../../composant/Graphe/AffichageGraphe/LabelEventGraph/demo/LabelEventGraphGeoDemo';

const ConteneurCentral = ({ montrerMenu }) => {
  const projectIdUrl = useSelector(
    (state) => state.interfaceClient.project_id_url
  );

  const containerStyles = [
    styles.ConteneurCentral,
    styles.SansEnTete,
    montrerMenu ? styles.AvecMenu : styles.SansMenu,
  ].join(' ');

  return (
    <div className={containerStyles}>
      <Routes>
        <Route
          path={url.projet}
          element={
            <AccesRestreins numPrivilege={privilege.acces_a_l_interface_admin}>
              <Projet />
            </AccesRestreins>
          }
        />
        <Route
          path={url.filtre}
          element={
            <AccesRestreins numPrivilege={privilege.acces_a_l_interface_admin}>
              <FiltreParProjet />
            </AccesRestreins>
          }
        />
        <Route
          path={url.capteur}
          element={
            <AccesRestreins numPrivilege={privilege.acces_a_l_interface_admin}>
              <Capteur />
            </AccesRestreins>
          }
        />
        <Route
          path={url.graphe}
          element={
            <AccesRestreins numPrivilege={privilege.acces_a_l_interface_admin}>
              <Graphe />
            </AccesRestreins>
          }
        />
        <Route
          path={url.vue}
          element={
            <AccesRestreins numPrivilege={privilege.acces_a_l_interface_admin}>
              <Vue />
            </AccesRestreins>
          }
        />
        <Route
          path={url.alarme}
          element={
            <AccesRestreins numPrivilege={privilege.acces_a_l_interface_admin}>
              <AlarmeAdmin />
            </AccesRestreins>
          }
        />
        <Route
          path={url.rapport}
          element={
            <AccesRestreins numPrivilege={privilege.acces_a_l_interface_admin}>
              <Rapport />
            </AccesRestreins>
          }
        />
        <Route
          path={url.utilisateur}
          element={
            <AccesRestreins numPrivilege={privilege.acces_a_l_interface_admin}>
              <Utilisateur />
            </AccesRestreins>
          }
        />
        <Route
          path={url.tasks}
          element={
            <AccesRestreins numPrivilege={privilege.acces_a_l_interface_admin}>
              <Tasks />
            </AccesRestreins>
          }
        />
        <Route
          path={url.gestionDonnees}
          element={
            <AccesRestreins numPrivilege={privilege.acces_a_l_interface_admin}>
              <GestionDonnees />
            </AccesRestreins>
          }
        />
        <Route
          path={url.gddm}
          element={
            <AccesRestreins numPrivilege={privilege.acces_a_l_interface_admin}>
              <SensorDataTab />
            </AccesRestreins>
          }
        />
        <Route
          path={url.maintenance}
          element={
            <AccesRestreins numPrivilege={privilege.acces_a_l_interface_admin}>
              <Maintenance />
            </AccesRestreins>
          }
        />
        <Route
          path={url.AideAdmin}
          element={
            <AccesRestreins numPrivilege={privilege.acces_a_l_interface_admin}>
              <AideAdmin />
            </AccesRestreins>
          }
        />
        <Route
          path="/planning/:viewId"
          element={
            <AccesRestreins numPrivilege={privilege.acces_a_l_interface_admin}>
              <PlanningVue />
            </AccesRestreins>
          }
        />
        <Route
          path="/export_impression_ecran-visualisation-2269/:viewId"
          element={
            <AccesRestreins numPrivilege={privilege.acces_a_l_interface_admin}>
              <PlanningVue />
            </AccesRestreins>
          }
        />
        <Route
          path={url.accueil}
          element={<OngletsClient montrerMenu={montrerMenu} />}
        />
        <Route
          path={url.demo_label_event_graph_geo}
          element={<LabelEventGraphGeoDemo />}
        />
        <Route path={url.profil} element={<Profil />} />
        <Route path={url.Formation} element={<Formation />} />
        <Route path={url.Info} element={<Info />} />
        <Route
          path={url.regex_projet_client}
          element={
            <InterfaceClient
              montrerMenu={montrerMenu}
              project_id={projectIdUrl}
            />
          }
        />
      </Routes>
    </div>
  );
};

export default ConteneurCentral;
